import { render } from "./Services-manufacturers-en.vue?vue&type=template&id=20dc42b2&scoped=true"
import script from "./Services-manufacturers-en.vue?vue&type=script&lang=js"
export * from "./Services-manufacturers-en.vue?vue&type=script&lang=js"

import "./Services-manufacturers-en.vue?vue&type=style&index=0&id=20dc42b2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20dc42b2"]])

export default __exports__